import subscriptionStatuses, { SubscriptionStatus } from 'common/helpers/constants/subscriptionStatuses'


const userStatuses = {
  active: 'active',
  inactive: 'inactive',
  user: 'user',
  pause: 'pause',
  cancelled: 'cancelled',
  unpaid: 'unpaid',
  undeliverable: 'undeliverable',
  pending: 'pending',
} as const

type UserStatus = keyof typeof userStatuses

const getMixpanelSubscriptionStatus = (subscriptionStatus: SubscriptionStatus): UserStatus => ({
  [subscriptionStatuses.notSubscribed]: userStatuses.user,
  [subscriptionStatuses.active]: userStatuses.active,
  [subscriptionStatuses.onHold]: userStatuses.active,
  [subscriptionStatuses.waitingProlong]: userStatuses.active,
  [subscriptionStatuses.unpaid]: userStatuses.unpaid,
  [subscriptionStatuses.pending]: userStatuses.pending,
  [subscriptionStatuses.cancelled]: userStatuses.cancelled,
  [subscriptionStatuses.notAuthorized]: userStatuses.user,
  [subscriptionStatuses.paused]: userStatuses.pause,
  [subscriptionStatuses.undeliverable]: userStatuses.undeliverable,
  [subscriptionStatuses.pendingUpgrade]: userStatuses.active,
  [subscriptionStatuses.pendingChangePlan]: userStatuses.active,
})[subscriptionStatus] || userStatuses.user


export default getMixpanelSubscriptionStatus
